module.exports = __webpack_public_path__ + "img/benefit_la-bowl_pre-game-tailgate.caac80f9.jpg";